module.exports = __webpack_public_path__ + "img/16.6d0e9f0a.webp";